import { Component } from 'react'
import { AgentStatusToggle } from '@driftt/tide-core-legacy'
import styles from './styles'

const resolveAgentStatus = ({
  isActive,
  limitNumChatsEnabled,
  isUserAtConversationLimit,
}) => {
  if (limitNumChatsEnabled && isUserAtConversationLimit && isActive) {
    return 'chat-limit'
  }

  if (isActive) {
    return 'available'
  }

  return 'away'
}

const resolveStatusDetails = ({
  isActive,
  limitNumChatsEnabled,
  limitNumChats,
  isUserAtConversationLimit,
}) => {
  if (limitNumChatsEnabled && isUserAtConversationLimit && isActive) {
    return `Conversation limit reached (${limitNumChats})`
  }

  if (isActive) {
    return 'Accepting new conversations'
  }

  return 'Not accepting new conversations'
}

const resolveStatusLabel = ({
  isActive,
}) => {
  return isActive
   ? 'Available'
   : 'Away'
}

class AgentStatusPane extends Component {
  resolveStatusLabel = () => {
    const { isActive } = this.props

    return resolveStatusLabel({ isActive })
  }

  resolveStatusDetails = () => {
    const {
     isActive,
     limitNumChatsEnabled,
     limitNumChats,
     isUserAtConversationLimit,
    } = this.props

    return resolveStatusDetails({
      isActive,
      limitNumChatsEnabled,
      limitNumChats,
      isUserAtConversationLimit,
    })
  }

  resolveAgentStatus = () => {
    const {
      isActive,
      limitNumChatsEnabled,
      isUserAtConversationLimit,
    } = this.props

    return resolveAgentStatus({
      isActive,
      limitNumChatsEnabled,
      isUserAtConversationLimit,
    })
  }

  handleAgentStatusToggled = () => {
    this.props.toggleStatus({ source: this.props.source })
  }

  render () {
    const {
      displayName,
      isActive,
    } = this.props

    return (
      <div className={styles['agent-status-pane']}>
        <div className="agent-status-information">
          <div className="agent-identifier">
            {displayName && (
              <div className="agent-display-name">
                {displayName}
              </div>
            )}
            <div className="agent-status-label">
              {this.resolveStatusLabel()}
            </div>
          </div>
          <div className="agent-status-details">
            {this.resolveStatusDetails()}
          </div>
        </div>
        <AgentStatusToggle
          className="agent-status-toggle"
          agentStatus={this.resolveAgentStatus()}
          checked={isActive}
          onChange={this.handleAgentStatusToggled}/>
      </div>
    )
  }
}

export default AgentStatusPane



// WEBPACK FOOTER //
// ./src/scripts/components/AgentStatusPane/component.js